import { Avatar } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
export const Contributor = ({ name, link }) => {
  return (
    <li className="contributor mt-1 fw-400">
      <div className="contributor-item">
        <Link target="_blank" href={link} className="flex ai-c link text-blue">
          <Avatar className="mr-1 contributor-avatar" />
          <span className="contributor-name">{name}</span>
        </Link>
      </div>
    </li>
  );
};
